import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
}), 'SignalCellularNullOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularNullOutlined.js
// module id = 6194
// module chunks = 2